import { Tables } from "@/lib/supabase/supabase_types_override";
import { Configuration, FullConfiguration } from "@/types/crm/configuration/configuration";
import { mergeConfigurations } from "./configuration";



export function matchConfigurationData(
    crm?: Tables<'crm'>,
    configuration?: Configuration | null,
    crmProject?: Tables<'crm_project'> | null,
    crmConfig?: Tables<'crm_config'> | null,
    question?: Tables<'question'> | null,
): FullConfiguration | undefined {
    if(!crm || !configuration) return undefined
    const configurationData = crm?.configuration_data
    const crmSelectedConfiguration = crm?.selected_configuration
    const crmProjectSelectedConfiguration = crmProject?.selected_configuration
    const crmConfigSelectedConfiguration = crmConfig?.selected_configuration
    const questionSelectedConfiguration = question?.selected_configuration
    if (!configuration) return undefined
    return {
        parameter: {
            crm: configuration.parameter?.crm?.map((parameter) => {
                const selectedParameter = crmSelectedConfiguration?.parameter?.find((p) => p.id === parameter.id)
                const options = configurationData?.parameter.crm?.[parameter.id]
                const result = {
                    id: parameter.id,
                    name: parameter.name,
                    value: selectedParameter?.value,
                    options: options,
                    settings: parameter.settings
                };
                return result;
            }),
            project: configuration.parameter?.project?.map((parameter) => {
                const selectedParameter = crmProjectSelectedConfiguration?.parameter?.find((p) => p.id === parameter.id)
                const options = configurationData?.parameter.project?.[parameter.id]
                return {
                    id: parameter.id,
                    name: parameter.name,
                    value: selectedParameter?.value,
                    options: options,
                    settings: parameter.settings
                }
            }),
            survey: configuration.parameter?.survey?.map((parameter) => {
                const selectedParameter = crmConfigSelectedConfiguration?.parameter?.find((p) => p.id === parameter.id)
                const options = configurationData?.parameter.survey?.[parameter.id]
                return {
                    id: parameter.id,
                    name: parameter.name,
                    value: selectedParameter?.value,
                    options: options,
                    settings: parameter.settings
                }
            }),
            question: configuration.parameter?.question?.map((parameter) => {
                const selectedParameter = questionSelectedConfiguration?.parameter?.find((p) => p.id === parameter.id)
                const options = configurationData?.parameter.question?.[parameter.id]
                return {
                    id: parameter.id,
                    name: parameter.name,
                    value: selectedParameter?.value,
                    options: options,
                    settings: parameter.settings
                }
            })
        }
    }
}

export function matchDefaultConfigurationData(
    crm?: Tables<'crm'>, 
    crmProject?: Tables<'crm_project'> | null, 
    crmConfig?: Tables<'crm_config'> | null,
    question?: Tables<'question'> | null,
): FullConfiguration | undefined {
    const configuration = crm?.default_configuration as Configuration | undefined
    if (!configuration) return undefined
    return matchConfigurationData(crm, configuration, crmProject, crmConfig, question)
}
export function matchConfigurationDataWithDefault(
    crm?: Tables<'crm'>,
    crmProject?: Tables<'crm_project'> | null,
    crmConfig?: Tables<'crm_config'> | null,
    question?: Tables<'question'> | null,
): FullConfiguration | undefined {
    const configuration = mergeConfigurations(crm?.default_configuration as Configuration | undefined, crm?.configuration as Configuration | undefined)
    if (!configuration) return undefined
    return matchConfigurationData(crm, configuration, crmProject, crmConfig, question)
}

export function matchConfigurationDataGrouped(
    crm?: Tables<'crm'>, 
    crmProject?: Tables<'crm_project'> | null, 
    crmConfig?: Tables<'crm_config'> | null,
    question?: Tables<'question'> | null,
) {
    if(!crm?.configuration) return undefined
    return {
        configuration: matchConfigurationData(crm, crm?.configuration, crmProject, crmConfig, question),
        defaultConfiguration: matchDefaultConfigurationData(crm, crmProject, crmConfig, question),
        withDefaultConfiguration: matchConfigurationDataWithDefault(crm, crmProject, crmConfig, question)
    }
}